var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('data-grid',{ref:"grid",staticClass:"camp-calls-list",attrs:{"url":_vm.url,"columns":_vm.columns,"title":_vm.title,"hideHeader":true,"hideActions":true,"selectionEnabled":false,"beforeSetupGrid":_vm.beforeSetupGrid,"perPage":10,"sortOptions":{
            enabled: true,
            field: 'date',
            type: 'desc',
        },"expandedOptions":{
            enabled: true,
            template: 'camp-call-details',
        }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }